(function () {
  function hasDirectImage(card) {
    var children = card.children;

    for (var i = 0; i < children.length; i++) {
      if (
        children[i].tagName &&
        children[i].tagName.toLowerCase() === "img"
      ) {
        return true;
      }
    }

    return false;
  }

  function createTitle(widget) {
    if (!widget || widget.querySelector(".zoka-jdgm-title")) return;

    var title = document.createElement("h2");
    title.className = "zoka-jdgm-title";
    title.innerHTML =
      '<span class="zoka-jdgm-title__main">Nuestros <span class="zoka-jdgm-title__air">Clientes</span></span>';

    widget.prepend(title);
  }

  function createAvatar() {
    var avatar = document.createElement("div");
    avatar.className = "zoka-review-avatar";
    avatar.setAttribute("aria-hidden", "true");
    return avatar;
  }

  function processCards() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (!widget) return;

    createTitle(widget);

    var cards = widget.querySelectorAll(".jdgm-carousel-item");

    cards.forEach(function (card) {
      var textBlock = card.querySelector(".jdgm-text");
      if (!textBlock) return;

      var oldAvatar = card.querySelector(".zoka-review-avatar");
      if (oldAvatar) oldAvatar.remove();

      if (hasDirectImage(card)) return;

      var avatar = createAvatar();
      card.insertBefore(avatar, textBlock);
    });
  }

  function init() {
    processCards();
    setTimeout(processCards, 600);
    setTimeout(processCards, 1500);
    setTimeout(processCards, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();